import { Injectable } from '@angular/core';

// Drop-in replacement for ngx-webstorage's LocalStorageService (the only
// methods actually used across this app are store/retrieve/clear).
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  store(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  retrieve<T = any>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (item === null) {
      return null;
    }
    try {
      return JSON.parse(item) as T;
    } catch {
      return null;
    }
  }

  clear(key: string): void {
    localStorage.removeItem(key);
  }
}
